<script>
  import { onMount, beforeUpdate } from 'svelte'
  import { tweened } from 'svelte/motion'
	import { quintInOut } from 'svelte/easing'

  /** @type {number} */
  export let value = undefined

  /** 
   * Setting this option to true will ignore the numberOfDecimals use the money formatter ($123,456.78)
   * For a 'decorative' money effect (e.g. for $132M) set the decimal value to what makes sense,
   * and set the suffix and prefix.
   * @type {boolean} 
  */
  export let isMoney = false

  /** @type {string} */
  export let prefix = ''

  /** @type {string} */
  export let suffix = ''

  /** @type {number} */
  export let numberOfDecimals = 0

  /** @type {number} */
  export let animationDuration = 2000

  /** @type {number} */
  export let animationDelay = 150

  let className
  export { className as class }

  let displayNumber

  export let tag = 'span'

  // https://stackoverflow.com/questions/149055/how-to-format-numbers-as-currency-strings
  const moneyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',

    // These options are needed to round to whole numbers if that's what you want.
    //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
    //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
  })

  const motionNumber = tweened(0, {
    delay: animationDelay,
		duration: animationDuration,
		easing: quintInOut
	})

  $: {
    if(isMoney) {
      displayNumber = moneyFormatter.format($motionNumber)
    } else {
      displayNumber = numberOfDecimals > 0 ? $motionNumber.toFixed(numberOfDecimals) : Math.floor($motionNumber).toLocaleString("en-US")
    }
  }

  $: $motionNumber = value
</script>

<svelte:element this={ tag } class="animated-value{ className ? ' ' + className : '' }">
  { prefix }{ displayNumber }{ suffix }
</svelte:element>